import api from "../Service/Api";
import { toastr } from "react-redux-toastr";
import generalFunc from "../Utils/generalFunc";
import {
  noNetworkMsg,
  exErrMsg,
  successMsg,
  errorMsg,
  clearMsg,
  infoMsg,
} from "../Utils/apiToasts";
import { offline } from "../Constants/api";
import { controller } from "../Constants/api";

//===============Api for Create New Skill========================
export const createSkills = async (body) => {
  if (offline) {
    noNetworkMsg();
  } else {
    try {
      const response = await api.post(`${controller.skills}`, body);
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          successMsg("Added New Skill", "Success");
          return response.data.data;
        }
      } else {
        exErrMsg();
      }
    } catch (ex) {
      errorMsg(ex.response.data.message, "");
    }
  }
};

//===============Api for Get All Skills========================
export const getAllSkills = async (params) => {
  if (offline) {
    noNetworkMsg();
  } else {
    try {
      const response = await api.get(`${controller.skills}/get-all-skills`, {
        params,
      });
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          return response.data;
        }
      } else {
        exErrMsg();
      }
    } catch (ex) {
      errorMsg(ex.response.data.title, "");
    }
  }
};

//===============Api for Activate Skill by id========================
export const activateSkills = async (id) => {
  if (offline) {
    noNetworkMsg();
  } else {
    try {
      const response = await api.patch(
        `${controller.skills}/activate-skill-by-id?id=${id}`
      );
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          successMsg("Activated Skill", "Success");
          return response.data.data;
        }
      } else {
        exErrMsg();
      }
    } catch (ex) {
      exErrMsg();
    }
  }
};

//===============Api for Deactivate Skill by id========================
export const deactivateSkills = async (id) => {
  if (offline) {
    noNetworkMsg();
  } else {
    try {
      const response = await api.patch(
        `${controller.skills}/deactivate-skill-by-id?id=${id}`
      );
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          successMsg("Deactivated Skill", "Success");

          return response.data.data;
        }
      } else {
        exErrMsg();
      }
    } catch (ex) {
      exErrMsg();
    }
  }
};

//===============Api for Get Skill by id========================
export const getSkillsById = async (id) => {
  if (offline) {
    noNetworkMsg();
  } else {
    try {
      const response = await api.get(
        `${controller.skills}/get-skill-by-id?id=${id}`
      );
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          return response.data.data;
        }
      } else {
        exErrMsg();
      }
    } catch (ex) {
      exErrMsg();
    }
  }
};

//===============Api for Create Sub Skill========================
export const createSubSkill = async (body) => {
  if (offline) {
    noNetworkMsg();
  } else {
    try {
      const response = await api.post(
        `${controller.skills}/create-subskill`,
        body
      );
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          successMsg("Create Sub Skill", "Success");
          return response.data;
        }
      } else {
        exErrMsg();
      }
    } catch (ex) {
      exErrMsg();
    }
  }
};

//===============Api for get SubSkill by Skill id========================
export const getSubSkillBySkillId = async (id) => {
  if (offline) {
    noNetworkMsg();
  } else {
    try {
      const response = await api.get(
        `${controller.skills}/get-subskillunderskill?id=${id}`
      );
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          return response.data.data;
        }
      } else {
        exErrMsg();
      }
    } catch (ex) {
      exErrMsg();
    }
  }
};

//===============Api for Update Skill Set========================
export const updateSkillSet = async (body) => {
  if (offline) {
    noNetworkMsg();
  } else {
    try {
      const response = await api.put(`${controller.skills}/update-skill`, body);
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          successMsg("Updated Skill Set", "Success");

          return response.data.data;
        }
      } else {
        // exErrMsg();
      }
    } catch (ex) {
      if (ex.response.status === 400) {
        // errorMsg(ex.response.data.message, "Error");
      } else {
        errorMsg(ex.response.data.message, "Error");
      }
    }
  }
};

//===============Api for Update Sub Skill ========================
export const updateSubSkill = async (body) => {
  if (offline) {
    noNetworkMsg();
  } else {
    try {
      const response = await api.put(
        `${controller.skills}/update-sub-skill`,
        body
      );
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          successMsg("Updated Sub Skill", "Success");
          return response.data.data;
        }
      } else {
        
      }
    } catch (error) {
      console.log(error, "Error log")
      throw error;
    }
  }
};

//===============Api for Get All Skills Total Data========================
export const getAllTotalSkillsData = async () => {
  if (offline) {
    noNetworkMsg();
  } else {
    try {
      const response = await api.get(
        `${controller.skills}/get-total-skills-number`
      );
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          return response.data.data;
        }
      } else {
        exErrMsg();
      }
    } catch (ex) {
      exErrMsg();
    }
  }
};

//===============Api for get SkillCentre by State id========================
export const getSkillCentresByStateId = async (id) => {
  if (offline) {
    noNetworkMsg();
  } else {
    try {
      // toastr.info("Processing", "Please wait");
      const response = await api.get(
        `${controller.skillCenters}/get-all-skillcenters-by-state?stateId=${id}`
      );
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          // successMsg("Fetched Skill Centre", "Success");
          return response.data.data;
        }
      } else {
        exErrMsg();
      }
    } catch (ex) {
      exErrMsg();
    }
  }
};

//===============Api for Export Skills as CSV ========================
export const exportSkills = async () => {
  if (offline) {
    noNetworkMsg();
  } else {
    toastr.info("Downloading...", "Pending");
    await api
      .get(`${controller.skills}/export-skills`, { responseType: "blob" })
      .then((response) => {
        infoMsg("Downloading...");
        if (typeof response !== "undefined") {
          if (response.status === 200 || response.status === 204) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `SAED Skill Set ${generalFunc.getCurrentYear()}.xlsx`
            );
            document.body.appendChild(link);
            link.click();
            clearMsg();
            successMsg("Download Skills SpreadSheet", "Success");
          } else {
            clearMsg();
            errorMsg("Download Skills SpreadSheet", "Error in fetching API");
          }
        }
      })
      .catch((ex) => {
        clearMsg();
        exErrMsg();
      });
  }
};

//===============Api for Print Skills ========================
export const printSkills = async () => {
  if (offline) {
    noNetworkMsg();
  } else {
    // toastr.info("Opening Print Window...", "Pending");
    await api
      .get(`${controller.skills}/print-skills`, { responseType: "blob" })
      .then((response) => {
        // infoMsg("Opening Print Window...");
        if (typeof response !== "undefined") {
          if (response.status === 200 || response.status === 204) {
            const url = URL.createObjectURL(
              new Blob([response.data], { type: "application/pdf" })
            );
            var iframe = document.createElement("iframe");
            iframe.style.display = "none";
            iframe.src = url;
            document.body.appendChild(iframe);
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
            clearMsg();
            // successMsg("Print Skills SpreadSheet", "Success");
          } else {
            clearMsg();
            errorMsg("Print Skills SpreadSheet", "Error in fetching API");
          }
        }
      })
      .catch((ex) => {
        clearMsg();
        exErrMsg();
      });
  }
};


//===============Api for Update Multiple Sub Skill ========================
export const updateMultipleSubSkillApi = async (body) => {
  if (offline) {
    noNetworkMsg();
  } else {
    try {
      const response = await api.put(
        `${controller.skills}/update-multiple-sub-skills`,
        body
      );
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          successMsg("Updated Multiple Sub Skill", "Success");
          return response.data.data;
        }
      } else {
        // exErrMsg();
        toastr.error("hello world")
      }
    } catch (ex) {
      console.log(ex, "My EX")
      // toastr.error("hello")
      toastr.error(ex.response.data.message, "")
      
    }
  }
};


//===============Api for Import Skill Set ========================
export const importSkillSetApi = async (body) => {
  debugger
  if (offline) {
    noNetworkMsg();
  } else {
    try {
      const response = await api.post(
        `${controller.skills}/import-skills`,
        body
      );
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          debugger
          if(response.data.data.removedList.length > 0){
            debugger
            console.log("I am the problem")
            toastr.success("Sorry Set", "Success");
            return response.data.data;
          }else{
            successMsg("Import Skill Set", "Success");
            return response.data.data;
          }
        }
      } else {
        // exErrMsg();
        toastr.error("An error occured")
      }
    } catch (ex) {
      // toastr.error("hello")
      toastr.error(ex.response.data.message, "")
      
    }
  }
};



//===============Api for Import Sub Skill ========================
export const importSubSkillApi = async (body) => {
  debugger
  if (offline) {
    noNetworkMsg();
  } else {
    try {
      const response = await api.post(
        `${controller.skills}/import-sub-skills`,
        body
      );
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          successMsg("Import Sub Skill", "Success");
          return response.data.data;
        }
      } else {
        // exErrMsg();
        toastr.error("An error occured")
      }
    } catch (ex) {
      // toastr.error("hello")
      toastr.error(ex.response.data.message, "")
      
    }
  }
};